import { render, staticRenderFns } from "./CreateRate.vue?vue&type=template&id=8feb66a4&"
import script from "./CreateRate.vue?vue&type=script&lang=js&"
export * from "./CreateRate.vue?vue&type=script&lang=js&"
import style0 from "./CreateRate.vue?vue&type=style&index=0&id=8feb66a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports